import { render, staticRenderFns } from "./TotalField.vue?vue&type=template&id=65ef1674&"
import script from "./TotalField.vue?vue&type=script&lang=js&"
export * from "./TotalField.vue?vue&type=script&lang=js&"
import style0 from "./TotalField.vue?vue&type=style&index=0&id=65ef1674&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports